import {getCookie} from '../../utils/cookies'
import {firstAppLockedAnchorDealImpressionsTimestampConfig} from './cookieConfig'

export const getFirstAppLockedAnchorDealImpressionsTimestamp = () =>
  getCookie(firstAppLockedAnchorDealImpressionsTimestampConfig.name)
